import styled from "styled-components";
import { Form } from "antd";
import { font14pxSB } from "./Typography";

export default styled(Form.Item)`
  .ant-col.ant-form-item-label > label {
    ${font14pxSB}
  }
`;
